<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>
  <p-confirmdialog />
  <p-card>
    <ng-template #title>
      <h1>{{ 'catalog.contingents.title' | translate }}</h1>
    </ng-template>

    <div class="flex justify-end gap-2 mb-5">
      <p-button
        icon="fa fa-plus"
        [label]="'catalog.contingents.add' | translate"
        (onClick)="openCreateDialog()"
      />
    </div>

    <p-table
      [value]="contingentService.contingents()"
      stripedRows
      showGridlines
      dataKey="id"
      [paginator]="true"
      [rows]="25"
      [rowsPerPageOptions]="[25, 50, 75, 100]"
      sortField="title"
      [sortOrder]="1"
      [scrollable]="true"
      [tableStyle]="{ 'min-width': '40rem' }"
    >
      <ng-template #header>
        <tr>
          <th pSortableColumn="title">
            {{ 'catalog.contingents.fields.title' | translate }}
            <p-sortIcon field="title" />
          </th>
          <th>{{ 'catalog.contingents.fields.description' | translate }}</th>
          <th pSortableColumn="total_amount" class="w-32">
            {{ 'catalog.contingents.fields.totalAmount' | translate }}
            <p-sortIcon field="total_amount" />
          </th>
          <th pSortableColumn="instruction_amount" class="w-40">
            {{ 'catalog.contingents.fields.instructionAmount' | translate }}
            <p-sortIcon field="instruction_amount" />
          </th>
          <th pFrozenColumn alignFrozen="right" class="w-32"></th>
        </tr>
      </ng-template>
      <ng-template #body let-row>
        <tr>
          <td>{{ row.title }}</td>
          <td class="max-w-md truncate">{{ row.description }}</td>
          <td class="text-right">{{ row.total_amount }}</td>
          <td class="text-right">{{ row.instruction_amount }}</td>
          <td pFrozenColumn alignFrozen="right">
            <div class="flex items-center justify-end gap-2">
              <button
                pButton
                type="button"
                icon="fa fa-pencil"
                text
                rounded
                severity="secondary"
                (click)="openEditDialog(row)"
              ></button>
              <button
                pButton
                type="button"
                icon="fa fa-trash"
                text
                rounded
                severity="secondary"
                (click)="onRowDelete($event, row)"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="5" class="text-center italic text-color-secondary py-6">
            {{ 'catalog.contingents.empty' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>

  <p-dialog
    [header]="
      editing()
        ? ('catalog.contingents.edit' | translate)
        : ('catalog.contingents.add' | translate)
    "
    [modal]="true"
    [visible]="dialogVisible()"
    (visibleChange)="dialogVisible.set($event)"
    [closable]="!submitting()"
    [closeOnEscape]="!submitting()"
    [dismissableMask]="!submitting()"
    styleClass="w-[90vw] max-w-2xl"
    (onHide)="closeDialog()"
  >
    <form
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      class="flex flex-col gap-4"
    >
      <div class="flex flex-col">
        <label for="cont-title" class="text-sm mb-1">
          {{ 'catalog.contingents.fields.title' | translate }}
        </label>
        <input
          id="cont-title"
          pInputText
          formControlName="title"
          [maxlength]="255"
        />
        @if (form.get('title')?.touched && form.get('title')?.invalid) {
          <small class="text-red-500 mt-1">
            {{ 'validation.required' | translate }}
          </small>
        }
      </div>

      <div class="flex flex-col">
        <label for="cont-desc" class="text-sm mb-1">
          {{ 'catalog.contingents.fields.description' | translate }}
        </label>
        <textarea
          id="cont-desc"
          pTextarea
          formControlName="description"
          rows="3"
        ></textarea>
      </div>

      <div class="flex gap-4">
        <div class="flex flex-col flex-1">
          <label for="cont-total" class="text-sm mb-1">
            {{ 'catalog.contingents.fields.totalAmount' | translate }}
          </label>
          <p-inputNumber
            inputId="cont-total"
            formControlName="total_amount"
            [min]="0"
            [showButtons]="false"
          />
          @if (
            form.get('total_amount')?.touched &&
            form.get('total_amount')?.invalid
          ) {
            <small class="text-red-500 mt-1">
              {{ 'validation.required' | translate }}
            </small>
          }
        </div>
        <div class="flex flex-col flex-1">
          <label for="cont-instr" class="text-sm mb-1">
            {{ 'catalog.contingents.fields.instructionAmount' | translate }}
          </label>
          <p-inputNumber
            inputId="cont-instr"
            formControlName="instruction_amount"
            [min]="0"
            [showButtons]="false"
          />
          @if (form.get('instruction_amount')?.touched) {
            @if (form.get('instruction_amount')?.errors?.['required']) {
              <small class="text-red-500 mt-1">
                {{ 'validation.required' | translate }}
              </small>
            } @else if (
              form.get('instruction_amount')?.errors?.['custom'] ||
              form.get('instruction_amount')?.errors?.['server']
            ) {
              <small class="text-red-500 mt-1">
                {{ 'validation.instructionExceedsTotal' | translate }}
              </small>
            }
          }
        </div>
      </div>

      <div class="flex justify-end gap-2 pt-2">
        <p-button
          type="button"
          severity="secondary"
          [label]="'label.cancel' | translate"
          [disabled]="submitting()"
          (onClick)="closeDialog()"
        />
        <p-button
          type="submit"
          [label]="'label.save' | translate"
          [loading]="submitting()"
        />
      </div>
    </form>
  </p-dialog>
</div>
